import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareStaffingRoute: InvariantJiraRoute = {
	name: 'software-staffing',
	path: '/jira/software/projects/:projectKey/boards/:boardId/staffing',
	query: ['issueKey?'],
};
